import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { EducationService } from '../../../../../features/cv-builder/guided-cv-builder/education/education.service';
import { ValidationService } from '../../../../../shared/components/form-control/validation.service';
import { ActivatedRoute, Router } from '@angular/router';
import { InductionQuestionnaireService } from '../../../induction-questionnaire/induction-questionnaire.service';
import { ConfirmService } from '../../../../../shared/components/confirm-box/confirm-box.service';

export interface IRefData {
  id: number,
  identifier: string,
  description: string,
}

const VALIDATORS = {
  hasAddedValue: [ValidationService.ifChecked]
}

const EDUCATIONFORM_VALIDATORS_SAVE = {
  courseStartDate: [Validators.required, ValidationService.monthYearValidator, ValidationService.futureDate, ValidationService.pastYear(80)],
  courseEndDate: [ValidationService.monthYearValidator,
  ValidationService.invalidEndDateOrCurrent('courseStartDate', 'courseEndDate', 'isStudying'),
  ValidationService.invalidEndDateAndCurrent('courseEndDate', 'isStudying'),
  ValidationService.futureDate],
  institute: [Validators.required, Validators.maxLength(100)],
  courseTitle: [Validators.required, Validators.maxLength(100)],
  otherEducationType: [Validators.required, Validators.maxLength(200), Validators.pattern('[a-zA-Z0-9\\-\\s\&\(\)\/\.\'\,\"\:\;]*')],
  grade: [Validators.maxLength(100)],
  educationType: [Validators.required]
}


@Component({
  selector: 'vc-plan-employment',
  templateUrl: './plan-employment.component.html',
  styleUrls: ['./plan-employment.component.scss']
})
export class PlanEmploymentComponent implements OnInit {

  @Input('employmentDetails') public empList;
  @Output() refreshList = new EventEmitter<any>();

  employmentForm: FormGroup;
  educationTypes: IRefData[] = [];
  isDialogOpen = false;
  routeTo = '/plan/induction/page-six';
  isEditEmploymentClicked: boolean = false;

  constructor(
    private readonly educationService: EducationService,
    private readonly route: ActivatedRoute,
    private readonly fBuilder: FormBuilder,
    private readonly inductionQuestionnaireService: InductionQuestionnaireService,
    private readonly confirm: ConfirmService,
    private readonly router: Router,
  ) { }

  ngOnInit() {}

  deletePlanEmployment(id) {
    this.confirm.confirm({
      header: 'Confirm',
      message: 'Are you sure you want to delete an entry?',
      acceptLabel: 'Yes',
      rejectLabel: 'No',
      accept: () => {
        sessionStorage.setItem('isAssessmentInProgress', 'true');
        this.isDialogOpen = false;
        this.inductionQuestionnaireService.deleteEmployment(id).subscribe(Response => {
          this.refreshList.emit({});
        });
      },
      reject: () => {
        this.isDialogOpen = false;
      }
    });
    return this.confirm.navigateSelection;
  }

  EditPlanEmployment(id){
    this.isEditEmploymentClicked = true;
    this.router.navigate([this.routeTo], { queryParams: { id: id }, relativeTo: this.route });
  }

}
